import Vue from 'vue'
import BasicModel from '@/framework/basic/BasicModel'
Vue.directive('confirm', {
  bind: function (el, binding, vnode) {
    let _this = vnode.context
    let componentInstance = vnode.componentInstance

    let confirmText = componentInstance.$attrs['confirm-text']
    let confirmTitle = componentInstance.$attrs['confirm-title']
    el.onclick = function (e) {
      _this.$confirm(confirmText || '确认进行此操作？', confirmTitle || '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = componentInstance.$attrs['confirm-data']
        let requestUrl = componentInstance.$attrs['requestUrl']
        if (requestUrl) {
          BasicModel.post(_this, requestUrl, data, {
            success: function (dataInfo) {
              if (componentInstance.$listeners.onConfirm) {
                componentInstance.$listeners.onConfirm(dataInfo)
              }
            }
          })
        } else {
          if (componentInstance.$listeners.onConfirm) {
            componentInstance.$listeners.onConfirm(data)
          }
        }
      })
    }
  }
})
